import React from 'react';
import './CommentList.css';
import userAvatar from '../../assets/user-avatar.png';

function CommentList({ comments, loading }) {
    return (
        <div className="comments-list">
            <h3>Previous Comments</h3>
            {loading ? (
                <div className="loading-circle-small"></div>
            ) : (
                comments.map((comment) => (
                    <div key={comment.user_id} className="comment-item">
                        <div className="user-info">
                            <img src={userAvatar} alt="User Avatar" className="user-avatar" />
                            <p className="comment-user-name">{comment.user_name}</p>
                            <div className="rating small-stars">
                                {[1, 2, 3, 4, 5].map((star) => (
                                    <span
                                        key={star}
                                        className={`star ${comment.rating >= star ? 'filled' : ''}`}
                                    >
                                        &#9733;
                                    </span>
                                ))}
                            </div>
                        </div>
                        <div className="comment-content">
                            <p className="comment-text">{comment.comment_text}</p>
                        </div>
                        <p className="comment-date">{new Date(comment.comment_date).toISOString().split('T')[0]}</p>
                    </div>
                ))
            )}
        </div>
    );
}

export default CommentList;
